import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EngineConfigFilters = ({
  engineOptions,
  versionOptions,
  urlOptions,
  databaseOptions,
  filters,
  onFilterChange
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="filter-bar">
      <select
        className="form-control filter-select"
        value={filters.type}
        onChange={(e) => onFilterChange("type", e.target.value)}>
        <option value="">{t("Engine")}</option>
        {engineOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select
        className="form-control filter-select"
        value={filters.version}
        onChange={(e) => onFilterChange("version", e.target.value)}>
        <option value="">{t("Version")}</option>
        {versionOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select
        className="form-control filter-select"
        value={filters.url}
        onChange={(e) => onFilterChange("url", e.target.value)}>
        <option value="">{t("URL")}</option>
        {urlOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select
        className="form-control filter-select"
        value={filters.database}
        onChange={(e) => onFilterChange("database", e.target.value)}>
        <option value="">{t("Database")}</option>
        {databaseOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <div className="search-wrap">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="form-control"
          value={filters.search}
          onChange={(e) => onFilterChange("search", e.target.value)}
          placeholder={t("Search connections…")}
        />
      </div>
    </div>
  );
};

EngineConfigFilters.propTypes = {
  engineOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  versionOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  urlOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  databaseOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired
};

export default EngineConfigFilters;
